import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconItalic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"italic"} maskId="square-filled-radius-0-stroke-1-IconItalic"><path fillRule="evenodd" clipRule="evenodd" d="M8.91379 3H20V4H14.8741L10.1682 20H15.0862V21H4V20H9.12588L13.8318 4H8.91379V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconItalic;
